function simpleJsonPost(url, obj) {
  var xhr = new XMLHttpRequest();
  xhr.open('POST', url);
  xhr.setRequestHeader('Content-Type', 'application/json');
  xhr.send(JSON.stringify(obj));
}

var _createClass$1 = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck$1(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ErrorRegister = function () {
  function ErrorRegister() {
    _classCallCheck$1(this, ErrorRegister);

    this.register = [];
  }

  _createClass$1(ErrorRegister, [{
    key: 'addErrorToRegister',


    /**
     * Add error message to register
     * @param errorMessage
     */
    value: function addErrorToRegister(errorMessage) {
      this.register.push({
        time: new Date(),
        message: errorMessage
      });
    }

    /**
     * Checks if the same error message exists within given range. To prevent duplicate messages.
     * This is useful when you use the same JavaScript multiple times on the same page.
     * @param errorMessage
     * @param withinRange
     * @returns {boolean}
     */

  }, {
    key: 'isInRegisterWithinRange',
    value: function isInRegisterWithinRange(errorMessage, withinRange) {
      return this.register.filter(function (errorItem) {
        return errorItem.message === errorMessage && new Date() - errorItem.time < withinRange;
      }).length > 0;
    }
  }]);

  return ErrorRegister;
}();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var listeners = [];

var SimpleErrorReport = function () {
  function SimpleErrorReport(_ref) {
    var name = _ref.name,
        url = _ref.url,
        _ref$dryRun = _ref.dryRun,
        dryRun = _ref$dryRun === undefined ? true : _ref$dryRun,
        parseStack = _ref.parseStack;

    _classCallCheck(this, SimpleErrorReport);

    this.name = name;
    this.url = url;
    this.errorRegister = new ErrorRegister();
    this.dryRun = dryRun;
    if (parseStack) {
      this.parseStack = parseStack;
    }

    listeners.push(this.name);
  }

  /**
   * Listens for errors and unhandled promise rejection, then sends a report
   */


  _createClass(SimpleErrorReport, [{
    key: 'listenAndCatch',
    value: function listenAndCatch() {
      var _this = this;

      if (listeners.length <= 1) {
        window.addEventListener('error', function (e) {
          var message = e.message,
              url = e.filename,
              line = e.lineno,
              column = e.colno;

          var errObj = { message: message };
          if (url !== '') {
            errObj.url = url;
          }
          if (line > 0) {
            errObj.line = line;
          }
          if (column > 0) {
            errObj.column = column;
          }

          if (e.error && typeof _this.parseStack === 'function') {
            _this.parseStack(e.error).then(function (stackTrace) {
              _this.sendErrorReport(_extends({}, errObj, { stackTrace: stackTrace }));
            });
          } else {
            _this.sendErrorReport(errObj);
          }
        });

        window.addEventListener('unhandledrejection', function (e) {
          // const reason = typeof e.reason === 'object' && e.reason !== null ? JSON.stringify(e.reason) : e.reason
          // const reason = e.reason.toString()
          _this.sendErrorReport({ message: 'Unhandled Promise Rejection: ' + e.reason });
        });
      }
    }

    /**
     * sendErrorReport
     * Sends error report to dh-catch. It is naive and primitive on purpose, so you won't end up in an error loop
     * @param name
     * @param error
     */

  }, {
    key: 'sendErrorReport',
    value: function sendErrorReport(error) {
      if (!this.dryRun) {
        if (!this.errorRegister.isInRegisterWithinRange(error.message, 500)) {
          this.errorRegister.addErrorToRegister(error.message);
          simpleJsonPost(this.url + '/' + this.name, error);
        }
      } else {
        if (typeof console !== 'undefined') {
          console.log('Dry run: ' + JSON.stringify(error));
        }
      }
    }
  }]);

  return SimpleErrorReport;
}();

export { SimpleErrorReport };
